import { render, staticRenderFns } from "./DetpActivity.vue?vue&type=template&id=3d28c5bd&scoped=true"
import script from "./DetpActivity.vue?vue&type=script&lang=js"
export * from "./DetpActivity.vue?vue&type=script&lang=js"
import style0 from "./DetpActivity.vue?vue&type=style&index=0&id=3d28c5bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28c5bd",
  null
  
)

export default component.exports